import { useState } from 'react'
import GameResults from './GameResults'
import Standings from './Standings'
import Leaders from './Leaders'

// Ticker Data — feeds for the streaming ticker, as rows to paste into its sheet.
//
// Game results, division standings and scoring leaders. Results come from our
// stored box scores; standings and leaders come from the league's own pages,
// so they count games we never broadcast.
const TABS = [
  { id: 'results',   label: 'Game Results' },
  { id: 'standings', label: 'Standings' },
  { id: 'leaders',   label: 'Leading Scorers' },
]

export default function TickerDataModule() {
  const [tab, setTab] = useState('results')

  return (
    <div>
      <div style={{ marginBottom: 16 }}>
        <h2 style={{ marginBottom: 4 }}>Ticker Data</h2>
        <p className="muted">
          Game recaps, division standings and scoring leaders, formatted for the streaming
          ticker. Copy the rows and paste them into the ticker sheet.
        </p>
      </div>

      <div className="tab-bar" style={{
        display: 'flex', gap: 8, marginBottom: 16,
        borderBottom: '1px solid var(--border-color, #2a2a2a)',
        alignItems: 'center',
      }}>
        {TABS.map(t => (
          <button key={t.id} onClick={() => setTab(t.id)}
            style={{
              padding: '8px 16px',
              background: 'transparent',
              border: 'none',
              borderBottom: tab === t.id ? '2px solid var(--accent, #4a90e2)' : '2px solid transparent',
              color: tab === t.id ? 'var(--text-primary, #fff)' : 'var(--text-muted, #888)',
              cursor: 'pointer',
              fontWeight: tab === t.id ? 600 : 400,
            }}>
            {t.label}
          </button>
        ))}
      </div>

      {tab === 'results'   && <GameResults />}
      {tab === 'standings' && <Standings />}
      {tab === 'leaders'   && <Leaders />}
    </div>
  )
}
